/**
 * The one place the app is allowed to force a full page reload.
 *
 * Two reasons this wrapper exists rather than calling `window.location.reload()` at the call
 * sites. First, testability: jsdom's `Location` is spec-unforgeable and overriding it behaves
 * differently across jest/jsdom builds, so tests mock this module instead of fighting the
 * environment. Second, auditability: a forced reload destroys the player and any unsent state,
 * so every use of it should be findable in one search.
 */
export const reloadPage = (): void => {
    window.location.reload();
};
